import { createContext, type ReactNode, useContext, useState } from 'react';
import { usePhieuXuatDieuChuyenExport, useSearchFieldsState } from './hooks';
import { MA_CHUNG_TU, QUERY_KEYS } from '@/constants';
import { useCRUD } from '@/hooks';

interface ImportDialogState {
  isImportDialogOpen: boolean;
  openImportDialog: () => void;
  closeImportDialog: () => void;
}

interface PhieuXuatDieuChuyenContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  searchFields: ReturnType<typeof useSearchFieldsState>;
  transactionOptions: { value: string; label: string }[];
  import: ImportDialogState;
}

const PhieuXuatDieuChuyenContext = createContext<PhieuXuatDieuChuyenContextValue | null>(null);

export const usePhieuXuatDieuChuyenContext = () => {
  const context = useContext(PhieuXuatDieuChuyenContext);
  if (!context) {
    throw new Error('usePhieuXuatDieuChuyenContext must be used within PhieuXuatDieuChuyenProvider');
  }
  return context;
};

export const PhieuXuatDieuChuyenProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = usePhieuXuatDieuChuyenExport();
  const searchFields = useSearchFieldsState();
  const { data } = useCRUD({ endpoint: `${QUERY_KEYS.MA_GIAO_DICH}?ma_ct=${MA_CHUNG_TU.KHO.PHIEU_XUAT_DIEU_CHUYEN}` });
  const transactionOptions = data.map(item => ({
    value: item.uuid,
    label: item.ten_gd
  }));

  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const openImportDialog = () => setIsImportDialogOpen(true);
  const closeImportDialog = () => setIsImportDialogOpen(false);

  const importValue: ImportDialogState = {
    isImportDialogOpen,
    openImportDialog,
    closeImportDialog
  };

  return (
    <PhieuXuatDieuChuyenContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting,
        searchFields,
        transactionOptions,
        import: importValue
      }}
    >
      {children}
    </PhieuXuatDieuChuyenContext.Provider>
  );
};
